// // CustomerReport.js
// import React, { useEffect, useState } from 'react';
// import axios from 'axios'; // assuming you're using axios, or replace with your WebService
// import Button from 'react-bootstrap/Button';
// import Spinner from 'react-bootstrap/Spinner';
// import { WebService } from '../../Services/WebService';
// import CustomSeparator from "../../Services/BreadcrumbsComponent";
// import StaticListComponent from '../../Services/StaticListComponent';
// import { NoRecordTemplate } from '../../Services/TableComponent';
// import { StandardConst } from '../../Services/StandardConst';
// import { useDispatch } from 'react-redux';

// const CustomerReport = () => {
//   const [fetchingData, setFetchingData] = useState(false);
//   const [record, setRecord] = useState([]);
//   const [dateRange, setDateRange] = useState({});
//   const dispatch = useDispatch();

//   const fetchData = async (date) => {
//     try {
//       setDateRange(date);
//       setFetchingData(true);

//       let queryParams = `?startDate=${date.start}&endDate=${date.end}`;
//        const data = await WebService({
//         endPoint: `sales2/sales-visits${queryParams}`,
//         dispatch
//       });

//       const uniqueRetailerMap = new Map();

//       data.visits?.forEach((item) => {
//         const key = item.name?.trim();
//         if (key && !uniqueRetailerMap.has(key)) {
//           uniqueRetailerMap.set(key, {
//             BussinessName: item.BussinessName?.trim(),
//             retailer: item.name?.trim(),
//             locationName: item.address?.trim(),
//             PhoneNumber: item.phone?.trim(),
//             Email: item.email?.trim(),
//             latitude: item.locationLat,
//             longitude: item.locationLong,
//           });
//         }
//       });
//       console.log(uniqueRetailerMap)

//       const uniqueRetailers = Array.from(uniqueRetailerMap.values());
//       setRecord(uniqueRetailers);
//     } catch (error) {
//       console.error('Error fetching sales visits:', error);
//     } finally {
//       setFetchingData(false);
//     }
//   };

//   useEffect(() => {
//     fetchData({
//       start: '2000-01-01',
//       end:new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split("T")[0]
//     });
//   }, []);
// const MasterPageName = "Customer List";
//   const [bData, setBData] = React.useState([
//     {
//       title: "Company",
//       hrefLink: "#",
//     },
//     {
//       title: "Customer Visits",
//       hrefLink: "#",
//     },
//   ]);
//   const columns = [
//     {
//       Text: "Business",
//       Value: "BussinessName",
//     },
//     {
//       Text: "Customer",
//       Value: "retailer",
//     },
//         {
//       Text: "Phone",
//       Value: "PhoneNumber",
//     },
//     {
//       Text: "Email",
//       Value: "Email",
//     },
//     {
//       Text: "Address",
//       Value: "locationName",
//     },
//     {
//       Text: "Location",
//       Value: "coordinates",
//       render: (dr) => (
//         <a
//           href={`https://www.google.com/maps?q=${dr.latitude},${dr.longitude}`}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-primary underline"
//         >
//           {dr.latitude}, {dr.longitude}
//         </a>
//       ),
//     }
//   ]
//   return (
//     // <div className="container py-4">
//     //   <h4 className="mb-4">Customer Visit Report</h4>

//     //   {fetchingData && (
//     //     <div className="text-center my-3">
//     //       <Spinner animation="border" />
//     //     </div>
//     //   )}

//     //   {!fetchingData && record.length === 0 && (
//     //     <div className="alert alert-warning">No records found.</div>
//     //   )}

//     //   {record.map((item, index) => (
//     //     <div className="card mb-3 shadow-sm" key={index}>
//     //       <div className="card-body">
//     //         <h5 className="card-title">Customer Name: {item.retailer}</h5>
//     //         <p className="card-text">
//     //           <strong>Address:</strong> {item.locationName}
//     //         </p>
//     //         {item.latitude && item.longitude && (
//     //           <a
//     //             href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
//     //             target="_blank"
//     //             rel="noopener noreferrer"
//     //             className="btn btn-sm btn-outline-primary"
//     //           >
//     //             View Location on Google Maps
//     //           </a>
//     //         )}
//     //       </div>
//     //     </div>
//     //   ))}
//     // </div>
//        <>

//       <div className="d-flex flex-column mt-4 bg-white mx-2">
//         <div>
//           <h5 className="ms-2 mt-2">{MasterPageName}</h5>
//         </div>
//         <div className="ms-2 rounded-10">
//           <CustomSeparator bData={bData}></CustomSeparator>
//         </div>

//         <StaticListComponent
//           columns={columns}
//           records={record}
//           isSearchRequired={true}
//           allowSerialNo={true}

//           noRecordCss="p-0"
//           noRecordFound={
//             <NoRecordTemplate
//               headerValue="Customer list not  found"
//               subHeaderValue="Customer list not found"
//               imageUrl={StandardConst.imageNoRecordsFound}
//               />
//           }
//         />

//       </div>
//     </>

//   );
// };

// export default CustomerReport;

// CustomerReport.jsimport React, { useEffect, useState, useRef } from "react";

import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { WebService } from "../../Services/WebService";
import CustomSeparator from "../../Services/BreadcrumbsComponent";
import StaticListComponent from "../../Services/StaticListComponent";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { StandardConst } from "../../Services/StandardConst";
import { useDispatch } from "react-redux";
import ViewSalesVisit from "./ViewSalesVisit";
import ActionButton from "../../Services/ActionButton";

const CustomerReport = () => {
  const [fetchingData, setFetchingData] = useState(false);
  const [record, setRecord] = useState([]);
  const [dateRange, setDateRange] = useState({});
  const dispatch = useDispatch();

  const viewModalRef = useRef();

  const fetchData = async (date) => {
    try {
      setDateRange(date);
      setFetchingData(true);

      let queryParams = `?startDate=${date.start}&endDate=${date.end}`;
      const data = await WebService({
        endPoint: `sales2/sales-visits${queryParams}`,
        dispatch,
      });

      const uniqueRetailerMap = new Map();

      data.visits?.forEach((item) => {
        const key = item.name?.trim() + item.visitId;
        if (key && !uniqueRetailerMap.has(key)) {
          console.log("VD", item);
          uniqueRetailerMap.set(key, {
            visitId: item.visitId,
            BussinessName: item.BussinessName?.trim(),
            retailer: item.name?.trim(),
            address: item.address?.trim(),
            phone: item.phone?.trim(),
            Email: item.email?.trim(),
            purpose: item.purpose?.trim(),
            LocationLat: item.locationLat,
            LocationLong: item.locationLong,
            remarks: item.remarks || "",
            ScheduledDate: new Intl.DateTimeFormat("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }).format(new Date(item.scheduledDate)),
          });
        }
      });

      const uniqueRetailers = Array.from(uniqueRetailerMap.values());
      setRecord(uniqueRetailers);
    } catch (error) {
      console.error("Error fetching sales visits:", error);
    } finally {
      setFetchingData(false);
    }
  };

  useEffect(() => {
    fetchData({
      start: "2000-01-01",
      end: new Date(new Date().setDate(new Date().getDate() + 1))
        .toISOString()
        .split("T")[0],
    });
  }, []);

  const MasterPageName = "Customer List";
  const [bData] = useState([
    { title: "Company", hrefLink: "#" },
    { title: "Customer Visits", hrefLink: "#" },
  ]);

  const canEditDelete = (dr) => true; // You can put your logic here

  // const fnEdit = (visitId) => {
  //   console.log("Edit visit:", visitId);
  //   // call edit logic here
  // };

  // const refDelete = useRef({
  //   confirmAlert: (title, text, msg, visitId) => {
  //     if (window.confirm(`${title}: ${msg} ${visitId}`)) {
  //       console.log("Deleted visit:", visitId);
  //     }
  //   },
  // });

  const columns = [
    { Text: "Business", Value: "BussinessName" },
    { Text: "Customer", Value: "retailer" },
    { Text: "Phone", Value: "phone" },
    { Text: "Email", Value: "Email" },
    { Text: "Address", Value: "address" },
    { Text: "Remarks", Value: "remarks" },
  
    
    {
      Text: "location",
       render: (dr) => (
        <a
          href={`https://www.google.com/maps?q=${dr.latitude},${dr.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline"
        >
          {dr.LocationLat}, {dr.LocationLong}
        </a>
      ),
    
    },

    
    {
      Text: "Action",
      key: "visitId",
      cssClass: "text-center td-width-100",
      render: (dr) =>
        canEditDelete(dr) && (
          <div className="d-flex gap-2">
           
            <ActionButton
              IconTooltip="View"
              onClick={() => viewModalRef.current.openModal(dr)}
              IconName="View"
              id="viewvisit"
            />
            {/* <ActionButton
              IconTooltip="Edit"
              onClick={() => fnEdit(dr.visitId)}
              IconName="Edit"
              id="editvisit"
            />
            <ActionButton
              IconTooltip="Delete"
              onClick={() =>
                refDelete.current.confirmAlert(
                  "Delete",
                  "Are You Sure",
                  "Do you want to delete",
                  dr.visitId
                )
              }
              IconName="Delete"
              id="deletevisit"
            /> */}
          </div>
        ),
    },
  ];

  return (
    <>
      <div className="d-flex flex-column mt-4 bg-white mx-2">
        <div>
          <h5 className="ms-2 mt-2">{MasterPageName}</h5>
        </div>
        <div className="ms-2 rounded-10">
          <CustomSeparator bData={bData}></CustomSeparator>
        </div>

        {fetchingData && (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        )}

        {!fetchingData && record.length === 0 && (
          <NoRecordTemplate
            headerValue="Customer list not found"
            subHeaderValue="Customer list not found"
            imageUrl={StandardConst.imageNoRecordsFound}
          />
        )}

        <StaticListComponent
          columns={columns}
          records={record}
          isSearchRequired={true}
          allowSerialNo={true}
          noRecordCss="p-0"
        />
      </div>

      {/* View Modal */}
      <ViewSalesVisit
        ref={viewModalRef}
        callBackEvent={() => fetchData(dateRange)}
      />
    </>
  );
};

export default CustomerReport;
